import React from "react";

const ProjectDetails = () => {
  return (
    <>
      {/* project detail start  */}
      <section className="projectd__details-inner pt-150 pb-130">
        <div className="container">
          <div className="projectd__wrapper-inner">
            <div className="projectd__thumb">
              <img src="assets/imgs/inner/project-lg-1.jpg" alt="img" />
            </div>
            <div className="projectd__meta-inner">
              <div className="projectd__item-inner">
                <img src="assets/imgs/inner/project-d-1.png" alt="icon-1" />
                <div className="projectd__mcontent-inner">
                  <h4 className="title">Jermain Weeks</h4>
                  <span>CEO of Themum</span>
                </div>
              </div>
              <div className="projectd__item-inner">
                <img src="assets/imgs/inner/project-d-2.png" alt="icon-1" />
                <div className="projectd__mcontent-inner">
                  <h4 className="title">Jermain Weeks</h4>
                  <span>CEO of Themum</span>
                </div>
              </div>
              <div className="projectd__item-inner">
                <img src="assets/imgs/inner/project-d-3.png" alt="icon-1" />
                <div className="projectd__mcontent-inner">
                  <h4 className="title">Jermain Weeks</h4>
                  <span>CEO of Themum</span>
                </div>
              </div>
              <div className="projectd__item-inner">
                <img src="assets/imgs/inner/project-d-4.png" alt="icon-1" />
                <div className="projectd__mcontent-inner">
                  <h4 className="title">Jermain Weeks</h4>
                  <span>CEO of Themum</span>
                </div>
              </div>
            </div>
            <h2 className="projectd__details-title">Project Outline</h2>
            <p>
              We manage web development are many variations of passages of Lorem
              Ipsum available, but the majority have suffered alteration in some
              form, by injected humour, or randomised words which don't look
              even slightly believable. If you are going to use a passage of
              Lorem Ipsum, you need to be sure there isn't anything embarrassing
              hidden in the middle of text. All the Lorem Ipsum generators
              Established fact that a reader will be distracted b
            </p>
            <p>
              Established fact that a reader will be distracted by the readable
              content of a page when looking at its layout. The point of using
              Lorem Ipsum is that it has a more-or-less normal distribution of
              letters, as opposed to using 'Content here, content here', making
              it look like readable English. Many desktop publishing packages
              and web page editors now use Lorem Ipsum as their default model
              text, and a search for 'lorem ipsum' will uncover many web sites
              still in their infancy. Various versions have evolved over the
              year “Lorem Ipsum is simply dummy text of the printing and
              typesetting industry. Lorem Ipsum has been the industry's standard
              dummy text ever since the 1500s, when an unknown printer took a
              galley of type and scrambled”
            </p>
            <div className="projectd__checkboxwrapper">
              <div className="projectd__checkbox">
                <input
                  type="checkbox"
                  defaultChecked=""
                  name="checkbox"
                  id="checkbox"
                />
                <label htmlFor="checkbox">Ready for project overview</label>
              </div>
              <div className="projectd__checkbox">
                <input
                  type="checkbox"
                  defaultChecked=""
                  name="Creating"
                  id="Creating"
                />
                <label htmlFor="Creating">Creating Wireframe</label>
              </div>
              <div className="projectd__checkbox">
                <input
                  type="checkbox"
                  defaultChecked=""
                  name="Delivery"
                  id="Delivery"
                />
                <label htmlFor="Delivery">Delivery your projct</label>
              </div>
              <div className="projectd__checkbox">
                <input
                  type="checkbox"
                  defaultChecked=""
                  name="Research"
                  id="Research"
                />
                <label htmlFor="Research">Research your Brand Source</label>
              </div>
              <div className="projectd__checkbox">
                <input
                  type="checkbox"
                  defaultChecked=""
                  name="Finalize"
                  id="Finalize"
                />
                <label htmlFor="Finalize">Finalize Check your Projcet</label>
              </div>
              <div className="projectd__checkbox">
                <input
                  type="checkbox"
                  defaultChecked=""
                  name="Ready"
                  id="Ready"
                />
                <label htmlFor="Ready">Ready for project overview</label>
              </div>
            </div>
            <p>
              Web Development reader will be distracted by the readable content
              of a page when looking at its layout. The point of using Lorem
              Ipsum is that it has a more-or-less normal distribution of
              letters, as opposed to using 'Content here, content here', making
              it look like readable English. Many desktop publishing packages
              and web page editors now use Lorem Ipsum as their default model
              text, and a search for 'lorem ipsum' will uncover many web sites
              still in their infancy. Various versions have evolved over the
              year “Lorem Ipsum is simply dummy text of the printing and
              typesetting industry. Lorem Ipsum has been the industry's standard
              dummy text ever since the 1500s, when an unknown printer took a
              galley of type and scrambled”
            </p>
            <h3>Creating Wireframe</h3>
            <p>
              We manage web development are many variations of passages of Lorem
              Ipsum available, but the majority have suffered alteration in some
              form, by injected humour, or randomised words which don't look
              even slightly believable. If you are going to use a passage of
              Lorem Ipsum, you need to be sure there isn't anything embarrassing
              hidden in the middle of text. All the Lorem Ipsum generators
              Established fact that a reader will be distracted b
            </p>
            <p>
              Established fact that a reader will be distracted by the readable
              content of a page when looking at its layout. The point of using
              Lorem Ipsum is that it has a more-or-less normal distribution of
              letters, as opposed to using 'Content here, content here', making
              it look like readable English. Many desktop publishing packages
              and web page editors now use Lorem Ipsum as their default model
              text, and a search for 'lorem ipsum' will uncover many web sites
              still in their infancy. Various versions have evolved over the
              year “Lorem Ipsum is simply dummy text of the printing and
              typesetting industry. Lorem Ipsum has been the industry's standard
              dummy text ever since the 1500s, when an unknown printer took a
              galley of type and scrambled”
            </p>
            <div className="projectd__detailsthumb">
              <img src="assets/imgs/inner/blog-details-01.jpg" alt="thumb1" />
              <img src="assets/imgs/inner/blog-details-02.jpg" alt="thumb1" />
            </div>
            <h3>Delivery Your Project</h3>
            <p>
              We manage web development are many variations of passages of Lorem
              Ipsum available, but the majority have suffered alteration in some
              form, by injected humour, or randomised words which don't look
              even slightly believable. If you are going to use a passage of
              Lorem Ipsum, you need to be sure there isn't anything embarrassing
              hidden in the middle of text. All the Lorem Ipsum generators
              Established fact that a reader will be distracted b
            </p>
            <p>
              Established fact that a reader will be distracted by the readable
              content of a page when looking at its layout. The point of using
              Lorem Ipsum is that it has a more-or-less normal distribution of
              letters, as opposed to using 'Content here, content here', making
              it look like readable English. Many desktop publishing packages
              and web page editors now use Lorem Ipsum as their default model
              text, and a search for 'lorem ipsum' will uncover many web sites
              still in their infancy. Various versions have evolved over the
              year “Lorem Ipsum is simply dummy text of the printing and
              typesetting industry. Lorem Ipsum has been the industry's standard
              dummy text ever since the 1500s, when an unknown printer took a
              galley of type and scrambled”
            </p>
          </div>
        </div>
      </section>
      {/* /project detail start  */}
    </>
  );
};

export default ProjectDetails;
